
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { TagType, TagPayloadType } from "@/common/types/tag";

export async function tagList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `tag/list${queryString}`
    );
}

export async function tagGet(
    tag_id: string
) {
    return await clientAxios.get(
        `tag/${tag_id}/show`
    );
}

export async function tagCreate(
    payload: TagPayloadType
) {
    return await clientAxios.post(
        `tag/create`,
        payload
    );
}

export async function tagPatch(
    tag_id: string,
    payload: Partial<TagType>
) {
    return await clientAxios.patch(
        `tag/${tag_id}/patch`,
        { payload }
    );
}

export async function tagDel(
    tag_id: string,
) {
    return await clientAxios.del(
        `tag/${tag_id}/delete`,
    );
}
